var map = {
	"./01.jpg": 7598,
	"./02.jpg": 815,
	"./03.jpg": 5324,
	"./04.jpg": 1221,
	"./05.jpg": 3073,
	"./06.jpg": 1491,
	"./07.jpg": 3359,
	"./08.jpg": 4506,
	"./09.jpg": 4695,
	"./10.jpg": 8479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9217;